export class ViewerConstants {
  public static DISCRETE_ZOOM_LIMIT = 19;

  public static IMAGE_GALLERY_ZOOM_LIMIT = 19;

  public static DEFAULT_SEARCH_ZOOM = 20;

  public static MAX_FILE_SIZE_UPLOAD = 20; // MB

  public static COLLECTION_OFFSET = 20;

  public static USER_LAYER_BASE_ZINDEX = 100;

  public static COLLECTION_MODE_VISIBILITY = "VISIBILITY";

  public static COLLECTION_MODE_ORDER = "ORDER";

  public static COLLECTION_MODE_SELECTED = "ORDER";

  public static COLLECTION_TIMELINE_ZOOM_LEVEL = 16;

  public static IMAGE_GALLERY_HEIGHT = 450;

  public static WARNING_EXPIRE_DAYS = 14;

  public static DAMAGE_ASSESSMENT_MIN_YEAR = 2022;

  public static PIN_COLOR = "#d92a3e";

  public static INFRARED_PIN_COLOR = "#56D527";

  public static BANDS = {
    IRG: "irg",
    RGB: "rgb",
  };

  public static COVERAGE_TYPE_STATUS = {
    FINAL: "final-ortho",
    QUICK: "quick-ortho",
    DXM: "dxm-ortho",
    FIRST: "first-ortho",
  };

  public static STATUS_ORTHO = {
    PREVIEW: "Preview Ortho",
    FINAL: "Final Ortho",
    GRAYSKY: "Gray Sky Ortho",
  };

  public static COLLECTION_NAMES = {
    URBAN: "Urban Legacy",
    URBAN_G: "Urban G Legacy",
    URBAN_R: "Urban R Legacy",
    WIDE_AREA: "Wide Area Legacy",
    GRAYSKY: "Gray Sky Legacy",
    GRAYSKY_G: "Gray Sky G Legacy",
  };

  public static LAYER_SOURCE = {
    GRAYSKY: "graysky",
    GRAYSKY_G: "graysky-g",
    URBAN_G: "urban-g",
    URBAN_R: "urban-r",
    WIDE_AREA: "wide-area",
    URBAN: "urban",
  };

  public static LAYER_LABELS = {
    URBAN: "Urban",
    URBAN_G: "Urban G",
    URBAN_R: "Urban R",
    WIDE_AREA: "Wide Area",
    GRAYSKY: "Gray Sky",
    GRAYSKY_G: "Gray Sky G",
  };

  public static LAYER_NAMES = {
    GRAYSKY: "graysky",
    GRAYSKY_G: "graysky-g",
    URBAN_G: "bluesky-ultra-g",
    URBAN_R: "urban-r",
    WIDE_AREA: "bluesky-high",
    URBAN: "bluesky-ultra",
  };

  public static COLLECTION_PREFIX = {
    BLUESKY: "bluesky",
    GRAYSKY: "graysky",
  };

  public static COLLECTION_MODES = {
    VERTICAL: {
      value: "VERTICAL",
      name: "2D",
      orientations: {
        N: {
          name: "N",
          description: "North",
          azimut: 0,
        },
        S: {
          name: "S",
          description: "South",
          azimut: 180,
        },
        E: {
          name: "E",
          description: "East",
          azimut: 90,
        },
        W: {
          name: "W",
          description: "West",
          azimut: 270,
        },
      },
    },
    OBLIQUE: {
      value: "OBLIQUE",
      name: "3D",
      orientations: {
        N: {
          name: "N",
          description: "North",
          azimut: 0,
        },
        S: {
          name: "S",
          description: "South",
          azimut: 180,
        },
        E: {
          name: "E",
          description: "East",
          azimut: 90,
        },
        W: {
          name: "W",
          description: "West",
          azimut: 270,
        },
      },
    },
  };

  public static UNAUTHORIZED_ERROR = "Unauthorized";

  public static GEOMNI_PROVIDER = "geomni";

  public static OWNER_PROVIDER = "owner";

  public static GOOGLE_PROVIDER = "google";

  public static UNKNOWN_PROVIDER = "unknown";

  public static GEOGRAPHIC_CODE = 4326;

  public static SOURCE_NAME = {
    XYZ: "XYZ",
    WMS: "WMS",
    WFS: "WFS",
    WMTS: "WMTS",
    GEOMNI: "GEOMNI",
    BING: "BING",
    GOOGLE: "GOOGLE",
    OSM: "OSM",
    VECTOR: "VECTOR",
    VECTORTILES: "VECTORTILES",
    ARCGISFEATURE: "ARCGISFEATURE",
    COLLECTION: "COLLECTION",
    OBLIQUE: "OBLIQUE",
    GROUP: "GROUP",
    GEOTIFF: "GEOTIFF",
  };

  public static LAYER_TYPE = {
    BASELAYER: "BASELAYER",
    WMSLAYER: "WMSLAYER",
    WFSLAYER: "WFSLAYER",
    WMTSLAYER: "WMTSLAYER",
    GROUPLAYER: "GROUPLAYER",
    VECTORLAYER: "VECTORLAYER",
    COLLECTIONLAYER: "COLLECTION",
    OBLIQUELAYER: "OBLIQUE",
    MULTILAYER: "VEXCEL_MULTI_LAYER",
  };

  public static DISCRETE_ORIENTATIONS = {
    NOT_DEFINED: "*",
    V: "V",
    N: "N",
    S: "S",
    E: "E",
    W: "W",
    I: "I",
    NADIR: ["N*", "NN", "NS", "NE", "NW"],
  };

  public static OBLIQUE_ORIENTATIONS = ["N", "S", "E", "W"];

  public static PROJECTIONS = {
    WGS84: "EPSG:4326",
    WebMercator: "EPSG:3857",
  };

  public static FILTERS = ["Sharpen", "Sharpenless", "Blur", "Shadow", "Emboss", "Edge"];

  public static LAYER_ENHANCEMENTS = {
    COLOR_STRETCH: "COLOR_STRETCH",
  };

  public static LAYER_FILTERS = {
    CROP: "CROP",
    REPLACE_COLOR: "REPLACE_COLOR",
  };

  public static EXTERNAL_TOOLS = {
    MEASURE_LINE: 0,
    MEASURE_AREA: 1,
    MEASURE_HEIGHT: 2,
    MEASURE_ELEVATION: 3,
    MEASURE_LINE_3D: 4,
    MEASURE_AREA_3D: 5,
    MEASURE_POINT_3D: 6,
    DRAW_LINE: 7,
    DRAW_BOX: 8,
    DRAW_POLYGON: 9,
    DRAW_CIRCLE: 10,
    ANNOTATION: 11,
    SCALE: 12,
    RESOLUTION: 13,
    EDITION: 14,
    DRAW_POINT: 15,
    CLEAR: 16,
    DRAW_BY_WKT: 17,
    MEASURE_POLYGON: 18,
    MEASURE_CIRCLE: 19,
    MEASURE_POINT_SURVEY: 20,
    MEASURE_POINT: 21,
    RELATIVE_MEASURE_POINT: 22,
    SELECTION_SQUARE: 23,
    SELECTION_POLYGON: 24,
    SELECTION_CIRCLE: 25,
    SELECTION_POINT: 26,
  };

  public static MAIN_TOOLS = {
    USER_INFO: 0,
    MEASUREMENT_TOOL: 1,
    DRAWING_TOOL: 2,
    EXPORT_TOOL: 3,
    OPTIONS_TOOL: 4,
  };

  public static VIEWER_INSTANCES_TYPES = {
    REGULAR_INSTANCE: 1,
    NO_NEARMAP_INSTANCE: 2,
    NEARMAP_INSTANCE: 3,
    WEATHER_INSTANCE: 4,
  };

  public static MEASUREMENT_TYPES = ["LineString", "Polygon", "Point", "GeometryCollection"];

  public static MEASURE_TYPE = {
    AREA: 0,
    LENGTH: 1,
    PERIMETER: 2,
    SLOPE: 3,
    HEIGHT: 4,
    RADIUS: 5,
    LENGTH_SEGMENTS: 6,
    CIRCUMFERENCE: 7,
  };

  public static IMPERIAL_UNITS = ["ft", "yd", "mi"];

  public static LENGTH_IMPERIAL_UNITS = ["ft", "yd", "mi"];

  public static AREA_IMPERIAL_UNITS = ["ft2", "yd2", "ac", "mi2"];

  public static METRIC_UNITS = ["m", "km"];

  public static LENGTH_METRIC_UNITS = ["m", "km"];

  public static AREA_METRIC_UNITS = ["m2", "ha", "km2"];

  public static SLOPE_UNITS = ["rise/run", "deg", "%"];

  public static GEOMETRY_TYPE = {
    MultiPoint: "MultiPoint",
    Point: "Point",
    MultiPolygon: "MultiPolygon",
    Polygon: "Polygon",
    MultiLine: "MultiLineString",
    Line: "LineString",
    GeometryCollection: "GeometryCollection",
  };

  public static MEASUREMENT_SYSTEMS = {
    IDS: {
      METRIC: 1,
      IMPERIAL: 0,
      MIXED: 3,
    },
    SYSTEMS: [
      {
        ID: 1,
        NAME: "Metric",
        DESCRIPTION: "(centimetres, metres, etc.)",
        UNITS: {
          LENGTH_SMALL: "cm",
          LENGTH_MIDDLE: "m",
          LENGTH_BIG: "km",
          AREA_SMALL: "sq cm",
          AREA_MIDDLE: "sq m",
          AREA_BIG: "sq km",
          SPEED: "km/h",
          PROBABILITY: "%",
        },
      },
      {
        ID: 0,
        NAME: "Imperial",
        DESCRIPTION: "(inches, feet, etc.)",
        UNITS: {
          LENGTH_SMALL: "in",
          LENGTH_MIDDLE: "ft",
          LENGTH_BIG: "mi",
          AREA_SMALL: "sq in",
          AREA_MIDDLE: "sq ft",
          AREA_BIG: "sq mi",
          SPEED: "mph",
          PROBABILITY: "%",
        },
      },
    ],
  };

  public static MEASURE_TOOLTIPS = "tooltip-for-measure tooltip-measure";

  public static SCALE_BAR_UNIT_SELECTOR = "unit-selector";

  public static SCALE_BAR_SELECTOR_CONTAINER = "scale-line-selector";

  public static CONTENT_COPY = "content_copy";

  public static REPORT_TYPES = {
    NONE: 0,
    PROPERTY: 1,
    DAMAGE: 2,
  };

  public static DOCK_GALLERY_IMG_SIZE = {
    WIDTH: 314,
    HEIGHT: 380,
  };

  public static IMAGE_GALLERY_MODES = {
    DOCK: 0,
    DIALOG: 1,
  };

  public static WKT_TYPES = {
    POINT: "POINT",
    MULTIPOINT: "MULTIPOINT",
    LINESTRING: "LINESTRING",
    MULTILINESTRING: "MULTILINESTRING",
    POLYGON: "POLYGON",
    MULTIPOLYGON: "MULTIPOLYGON",
    GEOMETRYCOLLECTION: "GEOMETRYCOLLECTION",
  };

  public static PROPERTY_FEATURES_TYPES = {
    STRUCTURE_GEOMETRY: {
      PARAMETER: "structure-geometry",
      NAME: "Building Footprints only",
    },
    STRUCTURE_ATTRIBUTES: {
      PARAMETER: "structure-attributes",
      NAME: "Building Attributes only",
    },
    PARCEL_ATTRIBUTES: {
      PARAMETER: "parcel-attributes",
      NAME: "Property Attributes only",
    },
    DEFAULT: {
      PARAMETER: "",
      NAME: "All attributes (default)",
    },
  };

  public static API_VERSION_2 = "v2";

  public static COLLECTION_TYPE_LAYERS = {
    bluesky: ["bluesky", "wide", "urban"],
    graysky: ["graysky"],
  };
}
